import { FormItemTypes } from '@bimser/core';
import { Form } from '..';

import _isEmpty from 'lodash/isEmpty';

export function getValueControl(form: Form, controlId: string, value: any) {
	const properties: any = form.items.get(controlId)?.properties.toJS();
	if (properties) {
		switch (properties.controlType) {
			case FormItemTypes.EControlTypes.Lookup: {
				if (
					properties.gridOptions?.selection?.mode == 'single' &&
					!_isEmpty(value) &&
					Array.isArray(value)
				) {
					value = value[0];
				}

				return value;
			}
			case FormItemTypes.EControlTypes.TreeSelect: {
				if (!properties?.multiple && !_isEmpty(value) && Array.isArray(value)) {
					value = value[0];
				}

				return value;
			}
			default:
				return value;
		}
	} else {
		return value;
	}
}
